// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__OqAmH","list":"PatternAutocomplete_list__2JRjE"};